import React from 'react';
export function GuaranteeSection() {
  return <section style={{
    background: '#061a10',
    padding: '80px 16px',
    textAlign: 'center',
    borderTop: '1px solid rgba(0,200,83,0.2)',
    borderBottom: '1px solid rgba(0,200,83,0.2)'
  }} data-id="element-109">
      <div style={{
      maxWidth: '580px',
      margin: '0 auto'
    }} data-id="element-110">
        {/* Shield icon */}
        <div style={{
        width: '80px',
        height: '80px',
        background: 'rgba(0,200,83,0.15)',
        border: '2px solid #00C853',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
        fontSize: '36px'
      }} data-id="element-111">
          🛡️
        </div>

        {/* Title */}
        <h2 style={{
        color: '#00C853',
        fontSize: 'clamp(28px, 5vw, 40px)',
        fontWeight: 900,
        textTransform: 'uppercase',
        margin: '0 0 20px',
        fontFamily: 'inherit',
        letterSpacing: '-0.02em'
      }} data-id="element-112">
          Probalo 15 días sin riesgo
        </h2>

        {/* Text */}
        <p style={{
        color: '#cbd5e1',
        fontSize: '18px',
        lineHeight: 1.8,
        margin: '0 0 32px'
      }} data-id="element-113">
          Si no te sirve, te devolvemos el dinero. Sin preguntas. Sin vueltas.
        </p>

        {/* Highlighted box */}
        <div style={{
        display: 'inline-block',
        border: '2px solid #00C853',
        borderRadius: '12px',
        padding: '16px 28px',
        color: '#00C853',
        fontSize: '18px',
        fontWeight: 700
      }} data-id="element-114">
          🛡️ Cero riesgo para vos. Todo el riesgo para nosotros.
        </div>
      </div>
    </section>;
}